// extracted by mini-css-extract-plugin
export default {"container":"FeatureCards--container--c-V3L"};